(function (window, document, $) {

    $(document).ready(function () {

        /**
         * Update YogaTV video section to get around full-page caching
         */
        function getVideo() {
            var utm_campaign = window.getUrlParameter('utm_campaign');

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'get_video',
                    post_id: themevars.post_id,
                    campaign: utm_campaign
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {

                $('[data-video-container]').html(result.data.video);

                // change dnt value if cookies accepted
                if (jQuery('[data-vimeo_id]').length) {
                    let dnt = $('[data-vimeo_id]').attr('data-vimeo_dnt');

                    // Get the iframe elements
                    document.querySelectorAll('iframe').forEach(iframe => {
                        if (iframe.src.includes("vimeo")) {
                            iframe.src = iframe.src.replace("dnt=1", "dnt=" + dnt);
                        }
                    });
                }
            });
        }

        if ($('[data-video-no-access]').length) {
            var utm_campaign = window.getUrlParameter('utm_campaign');

            if (utm_campaign) {
                $.ajax({
                    url: themevars.ajaxurl,
                    data: {
                        action: 'check_campaign',
                        post_id: themevars.post_id,
                        campaign: utm_campaign
                    },
                    type: 'POST',
                    dataType: 'json'
                }).done(function (result) {

                    if (result.data.pre_check === true) {
                        window.dispatchEvent( new Event('rmg_paywall_check_article_access') ); // trigger dap data listener
                    }
                });
            }

            // check if the paywall plugin is loaded, if not do the check right away
            if (typeof rmgPaywall !== 'undefined') {
                rmgPaywall.checkArticle(themevars.post_id, {'utm_campaign': utm_campaign}, function (access, context) {
                    getVideo();
                });
            } else {
                getVideo();
            }
        }

        /**
         * Show subscription block if not a subscriber
         */
        function showSubscriptionBlock() {
            if ($('.video-subscription-block').length < 1) {
                return;
            }

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'get_video_subscription_block',
                    post_id: themevars.post_id,
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) { 
                if (true !== result.success) {
                    return;
                }

                if ($('.video-subscription-block').length && result.data.subscription_block) {
                    $('.video-subscription-block').html(result.data.subscription_block);
                }
            });
        }

        showSubscriptionBlock();

        if ($('body.page-template-page-yogatv').length && $('[data-yogatv-spotlight]').length) {
            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'get_yogatv_data',
                    page: themevars.post_id
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (true !== result.success) {
                    return;
                }

                if ($('[data-greeting-word]').length && result.data.greeting_texts.greeting_word) {
                    $('[data-greeting-word]').html(result.data.greeting_texts.greeting_word);
                }

                if ($('[data-yogatv-spotlight]').length && result.data.yogatv_spotlight_videos) {
                    $('[data-yogatv-spotlight]').html(result.data.yogatv_spotlight_videos);
                }
            });
        }
    });

}(window, document, jQuery));
